import React from 'react';
import { IconFilter } from '@noths/polaris-client-ribbons-design-system';

import { NumericalLozenge } from 'src/components/atoms/NumericalLozenge/NumericalLozenge';
import type { ListingsHeaderRootCSS } from 'src/components/organisms/ListingsHeader/ListingsHeader.styles';
import * as styles from 'src/components/organisms/ListingsHeader/ListingsHeader.styles';

export interface ListingsHeaderProps {
  onButtonClick: () => void;
  stickyOffsetPx?: number;
  totalActiveFacetOptions: number;
  totalProducts: number;
}

export const ListingsHeader = ({
  onButtonClick,
  stickyOffsetPx = 0,
  totalActiveFacetOptions,
  totalProducts,
}: ListingsHeaderProps) => {
  const accessibleFilterLabel = `Filter options (${totalActiveFacetOptions} selected)`;

  return (
    <div
      css={styles.listingsHeaderRoot}
      style={
        {
          '--listingsHeaderTop': `${stickyOffsetPx}px`,
        } as ListingsHeaderRootCSS
      }
    >
      <p css={styles.totalProducts}>Showing {totalProducts} products</p>
      <button
        aria-label={accessibleFilterLabel}
        css={styles.listingsHeaderButton}
        onClick={onButtonClick}
        type="button"
      >
        {totalActiveFacetOptions > 0 && (
          <NumericalLozenge
            value={totalActiveFacetOptions > 99 ? '99+' : `${totalActiveFacetOptions}`}
          />
        )}
        Filter & Sort
        <IconFilter
          className="iconFilter"
          color="var(--neutral-white-base)"
          css={styles.iconFilter}
        />
      </button>
    </div>
  );
};
